import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import { Lock, User, AlertCircle } from 'lucide-react';
import '../styles/Login.css';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const user = await authService.login(username, password);
      onLogin(user);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fillDemoCredentials = (role) => {
    const credentials = {
      admin: { username: 'admin@leadec.com', password: 'Admin@123' },
      manager: { username: 'manager@leadec.com', password: 'Manager@123' },
      operator: { username: 'operator@leadec.com', password: 'Operator@123' },
      viewer: { username: 'viewer@leadec.com', password: 'Viewer@123' }
    };
    
    setUsername(credentials[role].username);
    setPassword(credentials[role].password);
    setError('');
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="login-overlay"></div>
      </div>
      
      <div className="login-content">
        <div className="login-card">
          <div className="login-header">
            <div className="logo-container">
              <div className="logo-icon">
                <Lock size={32} />
              </div>
              <h1>Leadec Smart Asset Tracking System</h1>
            </div>
          </div>

          {error && (
            <div className="error-message">
              <AlertCircle size={18} />
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username">
                <User size={18} />
                Username
              </label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your email"
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">
                <Lock size={18} />
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                disabled={loading}
              />
            </div>

            <button 
              type="submit" 
              className="login-button"
              disabled={loading}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div className="demo-credentials">
            <p className="demo-title">Demo Credentials:</p>
            <div className="demo-buttons">
              <button 
                onClick={() => fillDemoCredentials('admin')}
                className="demo-btn admin"
                disabled={loading}
              >
                Admin
              </button>
              <button 
                onClick={() => fillDemoCredentials('manager')}
                className="demo-btn manager"
                disabled={loading}
              >
                Manager
              </button>
              <button 
                onClick={() => fillDemoCredentials('operator')}
                className="demo-btn operator"
                disabled={loading}
              >
                Operator
              </button>
              <button 
                onClick={() => fillDemoCredentials('viewer')}
                className="demo-btn viewer"
                disabled={loading}
              >
                Viewer
              </button>
            </div>
          </div>

          <div className="login-footer">
            <p>Powered by SanCortex.ai</p>
            <p>Version 1.0</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;

